import { useEffect, useState } from 'react';

/**
 * useCookieBannerVisible
 *
 * Geeft `true` zolang de cookie-banner zichtbaar is. Andere drijvende UI-
 * elementen (Aa toegankelijkheid, ? hulp, FAB's) kunnen zich tijdelijk
 * verbergen zodat de gebruiker de Accepteren/Weigeren knoppen kan raken.
 *
 * CookieConsent.jsx dispatcht 'hoibuur:cookie-banner' events met
 * detail.visible bij elke state-verandering.
 */
export function useCookieBannerVisible() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = (e) => setVisible(!!e.detail?.visible);
    window.addEventListener('hoibuur:cookie-banner', handler);
    return () => window.removeEventListener('hoibuur:cookie-banner', handler);
  }, []);

  return visible;
}
